<template>
  <LegalDocView
    type="imprint"
    :title="$t('imprint.title') || 'Impressum'"
    :empty-text="$t('imprint.empty', 'Das Impressum wurde noch nicht veröffentlicht.')"
  >
    <!-- Fallback: the structured imprint object, shown only when no free-text
         Impressum is configured in the admin editor. -->
    <template v-if="imprint">
      <section>
        <h3 class="font-heading text-lg font-bold text-white mb-3">{{ imprint.companyName }}</h3>
        <div class="space-y-1">
          <p v-if="imprint.address">{{ imprint.address }}</p>
          <p v-if="imprint.zip || imprint.city">{{ [imprint.zip, imprint.city].filter(Boolean).join(' ') }}</p>
          <p v-if="imprint.country">{{ imprint.country }}</p>
        </div>
      </section>

      <section v-if="imprint.email || imprint.phone">
        <h3 class="font-heading text-sm font-bold text-white uppercase tracking-widest mb-3">Kontakt</h3>
        <div class="space-y-1">
          <p v-if="imprint.email">E-Mail: <a :href="'mailto:' + imprint.email" class="text-primary hover:underline">{{ imprint.email }}</a></p>
          <p v-if="imprint.phone">Telefon: <a :href="'tel:' + imprint.phone" class="text-primary hover:underline">{{ imprint.phone }}</a></p>
        </div>
      </section>

      <section v-if="imprint.managingDirector">
        <h3 class="font-heading text-sm font-bold text-white uppercase tracking-widest mb-3">Vertretungsberechtigt</h3>
        <p>{{ imprint.managingDirector }}</p>
      </section>

      <section v-if="imprint.registrationCourt || imprint.registrationNumber || imprint.taxId">
        <h3 class="font-heading text-sm font-bold text-white uppercase tracking-widest mb-3">Registrierung</h3>
        <div class="space-y-1">
          <p v-if="imprint.registrationCourt && imprint.registrationNumber">{{ imprint.registrationCourt }}, {{ imprint.registrationNumber }}</p>
          <p v-else-if="imprint.registrationCourt">{{ imprint.registrationCourt }}</p>
          <p v-else-if="imprint.registrationNumber">{{ imprint.registrationNumber }}</p>
          <p v-if="imprint.taxId">USt-IdNr.: {{ imprint.taxId }}</p>
        </div>
      </section>
    </template>
  </LegalDocView>
</template>

<script setup>
import LegalDocView from '~/components/Legal/LegalDocView.vue'

definePageMeta({
  title: 'Impressum'
})

const { data: imprint } = await useFetch('/api/public/imprint')
</script>
